<template>
  <section
    id="popular-destinations"
    class="section destinations with-counts"
    :class="{ desktop: $isDesktop }"
  >
    <translate v-if="$isDesktop" tag="h2" class="heading">
      Top destinations
    </translate>
    <div class="list">
      <pu-search-link
        v-for="location in data"
        :key="location.path"
        category="campsites"
        :hierarchy-path="location.path"
        exclude-type="newLocation"
        :modify-filters="{ categoryIds: undefined, facets: undefined }"
        @click="$emit('locationUrlClicked')"
      >
        {{ location.name }} <span>{{ location.count }}</span>
      </pu-search-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PopularLocation } from '~/apps/popular-locations/types'
import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { fetchWithCache } from '~/utility/fetchWithCache'

const route = useRoute()
const langCode = route.params.lang || 'en-gb'

const { data } = await useAsyncData(
  `popularDestiantions-${langCode}`,
  () => {
    const url = getLangFallbackUrl(langCode, '/search2/destinations/?limit=16')
    return fetchWithCache<PopularLocation[]>({ url })
  },
  // avoid duplicate requests server and client
  {
    server: true,
    lazy: process.client, // Defer fetching until client-side execution
    dedupe: 'cancel',
    getCachedData: (key, nuxt) => nuxt.payload.data[key] ?? undefined,
  },
)
</script>

<style scoped>
.list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(6em, max-content));
  column-gap: 1em;
  justify-content: space-between;
  align-items: center;

  padding: 0 1em 0.25em 1em;
  row-gap: 0.5em;
  font-size: var(--body);
}

.with-counts .list > a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1.1;
  text-decoration: none;

  background: #e1e6ef;
  border-radius: 0.5em;
  padding: 0.4em 0.5em;
}

a span {
  font-size: var(--small);
  color: var(--colour-text-light);
  margin-left: 0.75em;
  justify-self: flex-end;
}

.desktop .list {
  grid-template-columns: repeat(auto-fit, minmax(10em, max-content));
  column-gap: 2em;

  row-gap: 0;
  font-size: inherit;
  padding: 0;
}

.desktop .with-counts a {
  margin: 0.25em 0;

  background: none;
  border-radius: 0;
  padding: 0;
}
</style>
